export default [
    { name: 'Hora Marcada', value: 's' },
    //{ name: 'Ordem de chegada', value: 'o' }
];